import { isValutSegregationWalletInstance } from "../../../Services/baasAccountsListApi";
import { baasTransactionInstanceKey } from "./Transactions/baasTransactionsFilters";

/** Header filter: matriz own data (VALUT-GLOBAL). */
export const BAAS_LIST_FILTER_VALUT = "valut";
/** Header filter: every active instance. */
export const BAAS_LIST_FILTER_ALL = "all";

export const findBaasMatrixInstance = (instances = []) =>
  (instances || []).find((row) => isValutSegregationWalletInstance(row)) ?? null;

/** True when the console pin is Valut matrix — header filter is safe (no partner leak). */
export const canUseBaasGlobalInstanceFilter = (selectedInstance) =>
  isValutSegregationWalletInstance(selectedInstance);

export const getBaasListInstanceFilterOptions = (instances = [], selectedInstance = null) => {
  const env = selectedInstance?.environment;
  const seen = new Set();
  const matrix = findBaasMatrixInstance(instances) || selectedInstance;
  const others = (instances || [])
    .filter((row) => !env || !row?.environment || row.environment === env)
    .filter((row) => !isValutSegregationWalletInstance(row))
    .map((row) => {
      const id = baasTransactionInstanceKey(row?.baasInstanceId ?? row?.instanceId ?? row?.id);
      const label = String(row?.displayName || row?.name || id).trim();
      return { id, label };
    })
    .filter((row) => {
      if (!row.id || seen.has(row.id)) return false;
      seen.add(row.id);
      return true;
    })
    .sort((a, b) => a.label.localeCompare(b.label));

  return {
    matrix,
    others,
  };
};

/**
 * Numeric BaaS instance id for peer APIs, or null when the header is "all".
 * @returns {number|null}
 */
export const resolveBaasListInstanceNumericId = (
  filter,
  selectedInstance,
  instances = [],
) => {
  if (filter === BAAS_LIST_FILTER_ALL) return null;
  if (filter === BAAS_LIST_FILTER_VALUT) {
    const matrix = findBaasMatrixInstance(instances) || selectedInstance;
    const id = Number(matrix?.baasInstanceId ?? matrix?.instanceId);
    return Number.isFinite(id) ? id : null;
  }
  const id = Number(baasTransactionInstanceKey(filter));
  return Number.isFinite(id) ? id : null;
};

/** Fetch peer-* lists when matriz is pinned and the header is not Valut-only. */
export const shouldFetchBaasPeerLists = (selectedInstance, filter) =>
  canUseBaasGlobalInstanceFilter(selectedInstance) && filter !== BAAS_LIST_FILTER_VALUT;

/** Custody card + all-instance charts: matriz header set to "todas as instâncias". */
export const shouldShowBaasCustodyAggregate = (selectedInstance, filter) =>
  canUseBaasGlobalInstanceFilter(selectedInstance) && filter === BAAS_LIST_FILTER_ALL;

export const stampBaasRowInstance = (row, instance) => {
  if (!row) return row;
  const instanceId =
    row.instanceId ??
    instance?.baasInstanceId ??
    instance?.instanceId ??
    instance?.id ??
    null;
  const instanceName =
    row.instanceName ||
    instance?.displayName ||
    instance?.name ||
    null;
  return { ...row, instanceId, instanceName };
};

export const rowMatchesBaasListInstanceFilter = (
  row,
  filter,
  selectedInstance,
  instances = [],
) => {
  if (!canUseBaasGlobalInstanceFilter(selectedInstance)) return true;
  if (!filter || filter === BAAS_LIST_FILTER_ALL) return true;
  const wanted = resolveBaasListInstanceNumericId(filter, selectedInstance, instances);
  if (wanted == null) return true;
  const rowKey = baasTransactionInstanceKey(row?.instanceId ?? row?.baasInstanceId);
  if (!rowKey) {
    return filter === BAAS_LIST_FILTER_VALUT;
  }
  return rowKey === String(wanted);
};
